import CardBody from '@/components/ui/cards/CardBody';
import CardHeader from '@/components/ui/cards/CardHeader';
import { Input } from '@/components/ui/inputs/input';
import { InputSelect } from '@/components/ui/inputs/input-select';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import validationErrors from '@/lib/validationErrors';
import { getPaymentBySlugService, updatePaymentService } from '@/services/PaymentService';
import PermissionCheck from '@/components/common/PermissionCheck';

const PremierWalletsTab = ({ className }) => {
    const paymentModeList = [
        { value: '1', label: 'Live' },
        { value: '0', label: 'Sandbox' },
    ];
    const paymentStatus = [
        { value: 1, label: 'Enable' },
        { value: 2, label: 'Disable' },
    ];
    const {
        register,
        formState: { errors },
        handleSubmit,
        control,
        reset,
    } = useForm();
    const dispatch = useDispatch();
    const [isFormSumbmit, setIsFormSumbmit] = useState(false);

    useEffect(() => {
        getPayDetails();
    }, [dispatch, reset]);

    const getPayDetails = () => {
        dispatch(getPaymentBySlugService('premier_wallets'))
            .then((res) => {
                const paymentData = res?.data?.data?.[0];
                const gatewayOptions = Array.isArray(paymentData?.gateway_options) ? paymentData.gateway_options : [];
                reset({
                    payment_id: paymentData?._id || '',
                    status: paymentData?.status ?? 1,
                    premier_machine_id: gatewayOptions.find((option) => option?.option === 'premier_machine_id')?.value ?? '',
                    premier_wallet_id: gatewayOptions.find((option) => option?.option === 'premier_wallet_id')?.value ?? '',
                    premier_username: gatewayOptions.find((option) => option?.option === 'premier_username')?.value ?? '',
                    premier_password: gatewayOptions.find((option) => option?.option === 'premier_password')?.value ?? '',
                    premier_login_username:
                        gatewayOptions.find((option) => option?.option === 'premier_login_username')?.value ?? '',
                    premier_channel_id: gatewayOptions.find((option) => option?.option === 'premier_channel_id')?.value ?? '',
                    premier_device_type: gatewayOptions.find((option) => option?.option === 'premier_device_type')?.value ?? '',
                    premier_mode: String(
                        gatewayOptions.find((option) => option?.option === 'premier_mode')?.value ?? '1',
                    ),
                });
            })
            .catch(({ message, errorData }) => {
                validationErrors(errorData, message);
                setIsFormSumbmit(false);
            });
    };

    const onSubmit = (data) => {
        setIsFormSumbmit(true);
        const dataToSend = {
            id: data?.payment_id,
            status: data?.status,
            options: [
                {
                    option: 'premier_machine_id',
                    value: data?.premier_machine_id,
                },
                {
                    option: 'premier_wallet_id',
                    value: data?.premier_wallet_id,
                },
                {
                    option: 'premier_username',
                    value: data?.premier_username,
                },
                {
                    option: 'premier_password',
                    value: data?.premier_password,
                },
                {
                    option: 'premier_login_username',
                    value: data?.premier_login_username,
                },
                {
                    option: 'premier_channel_id',
                    value: data?.premier_channel_id,
                },
                {
                    option: 'premier_device_type',
                    value: data?.premier_device_type,
                },
                {
                    option: 'premier_mode',
                    value: data?.premier_mode,
                },
            ],
        };
        dispatch(updatePaymentService(dataToSend))
            .then((res) => {
                setIsFormSumbmit(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsFormSumbmit(false);
            });
    };
    return (
        <>
            <CardHeader isBorder={true}>
                <h3 className="db-card-title">Premier Wallets</h3>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <input type="hidden" {...register('payment_id')} />
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="premier_machine_id"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Machine Id'}
                                    type="text"
                                    id="premier_machine_id"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.premier_machine_id?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="premier_wallet_id"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Wallet ID'}
                                    type="text"
                                    id="premier_wallet_id"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.premier_wallet_id?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="premier_username"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'User Name'}
                                    type="text"
                                    id="premier_username"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.premier_username?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="premier_password"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Password'}
                                    type="text"
                                    id="premier_password"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.premier_password?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="premier_login_username"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Login User Name'}
                                    type="text"
                                    id="premier_login_username"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.premier_login_username?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="premier_channel_id"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Channel Id'}
                                    type="text"
                                    id="premier_channel_id"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.premier_channel_id?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true, minLength: 1 }}
                            name="premier_device_type"
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    size="sm"
                                    labelText={'Device Type'}
                                    type="text"
                                    id="premier_device_type"
                                    errorData={{ minLength: '1' }}
                                    errorType={errors?.premier_device_type?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true }}
                            name="premier_mode"
                            render={({ field }) => (
                                <InputSelect
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    id={'premier_mode'}
                                    labelText={'Mode'}
                                    value={paymentModeList.find((data) => data.value === String(field.value)) || null}
                                    onChange={(option) => field.onChange(option?.value ?? '')}
                                    options={paymentModeList}
                                    errorType={errors?.premier_mode?.type}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            rules={{ required: true }}
                            name="status"
                            render={({ field }) => (
                                <InputSelect
                                    {...field}
                                    labelStyleClassName="db-field-title required"
                                    id={'status'}
                                    labelText={'Status'}
                                    value={paymentStatus.find((data) => data.value === field.value) || null}
                                    onChange={(option) => field.onChange(option?.value ?? 1)}
                                    options={paymentStatus}
                                    errorType={errors?.status?.type}
                                />
                            )}
                        />
                        <PermissionCheck permsission={'update_settings'}>
                            <div className="sm:col-span-2">
                                <button type="submit" className="db-btn text-white bg-primary">
                                    <i className="lab lab-save"></i>
                                    <span>Save</span>
                                    {isFormSumbmit ? (
                                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    ) : (
                                        <></>
                                    )}
                                </button>
                            </div>
                        </PermissionCheck>
                    </div>
                </form>
            </CardBody>
        </>
    );
};

export default PremierWalletsTab;
